import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Gender({ item, index }) {

  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">Female</div>
    } else {
      return <>
        <div className="col-8">Sex Assigned at Birth </div>
        <div className="col-4">Female</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}